import { Component, Mixins } from 'vue-property-decorator';
import OrderGridsExcelDown from '@/components/common/order/mixins/OrderGridsExcelDown';

@Component
export default class OrderListGrids extends Mixins(OrderGridsExcelDown) {
  public gridProps: any = {
    header: {
      columns: [
        {
          name: 'exchange',
          renderer: (): any => {
            const el = document.createElement('div');
            const btn = document.createElement('button');
            btn.className = 'help';
            btn.id = 'exchangeHelpBtn';
            const onMousedown = (ev: any): any => {
              ev.stopPropagation();
            };
            btn.addEventListener('mousedown', onMousedown);
            return {
              getElement(): any {
                return el;
              },
              render(props: any): any {
                el.textContent = props.columnInfo.header;
                el.appendChild(btn);
              },
              beforeDestroy(): any {
                btn.removeEventListener('mousedown', onMousedown);
              }
            };
          }
        }
      ]
    },
    options: {
      header: {
        height: 33,
        bacground: '#ccc',
      },
      columnOptions: {
        minWidth: 50,
        resizable: true,
      },
      
      displayRowCount: 30,
      isInitialRequest: true,
      // keyColumnName: 'orderProductOptionNo',
      useClientSort: false,
      pageOptions: {
        perPage: 30,
        page: 1,
        totalCount: 0,
        centerAlign: true,
      },
      copyOptions: {
        useFormattedValue: true,
      },
    },
    // keyColumnName: 'orderProductOptionNo',
    columnOptions: {
      useFormattedValue: true,
    },
    showDummyRows: true,
    columns: [],
  };

  public listColumns: any = [
    '플랫폼구분',
    '쇼핑몰구분',
    '주문구분',
    '예약주문',
    '회원그룹',
    '추천인',
    '결제수단',
    '주문번호',
    '주문자명',
    '주문자 연락처',
    '배송보류',
    '회원번호',
    '교환여부',
    '배송구분',
    '업무메시지',
    '주문상태',
    '클레임상태',
    '파트너사',
    'HS CODE',
    '상품번호',
    '상품관리코드',
    '상품 이미지',
    '상품명',
    '영문상품명',
    '옵션관리코드',
    '옵션명: 옵션값',
    '판매가(할인적용가)',
    '추가할인',
    '추가할인적용가',
    '사은품 할인',
    '수량',
    '상품합계',
    '수령자명',
    '수령자휴대전화',
    '우편번호',
    '주소',
    '배송번호',
    '배송메모',
    '배송비 결제방식',
    '배송비 유형',
    '개인통관고유부호',
    '배송방법',
    '택배사',
    '송장번호',
    '주류구매 정보동의',
    '주문일시',
    '결제일시',
    '주문접수일시',
    '출고준비처리일시',
    '출고일시',
    '배송완료일시',
    '구매확정일시',
    '주문상품옵션번호',
    '정기결제(배송) 신청 번호',
    '적립금사용',
    '실결제금액',
  ];
}
